import { QUERY_KEYS } from "@/libraries/constant";
import { getCasesQueryOptions } from "@/queries";
import { CaseSearchParamSchema } from "@/schemas";
import { onlineManager } from "@tanstack/react-query";
import { Outlet, createFileRoute } from "@tanstack/react-router";
import { zodSearchValidator } from "@tanstack/router-zod-adapter";
import AppBarCase from "../-components/AppBar";

export const Route = createFileRoute("/dashboard/case/progress-notes")({
	validateSearch: zodSearchValidator(CaseSearchParamSchema),
	loaderDeps: () => ({
		status: location.pathname.endsWith("closed")
			? ("closed" as const)
			: ("active" as const),
	}),
	loader: ({ context, deps }) => {
		if (onlineManager.isOnline() && !context.isRestoring) {
			return context.queryClient.ensureInfiniteQueryData(
				getCasesQueryOptions({
					status: deps.status,
				}),
			);
		}
		return context.queryClient.getQueryData([
			QUERY_KEYS.GET_CASES,
			{
				status: deps.status,
			},
		]);
	},
	component: RouteComponent,
});

function RouteComponent() {
	return (
		<div className="relative flex-1 flex flex-col overflow-hidden">
			<AppBarCase
				variant="progress-notes"
				info="Select a case to view its progress notes"
			/>
			<Outlet />
		</div>
	);
}
